// extracted by mini-css-extract-plugin
module.exports = {"full-screen":"AuthLayout_full-screen__CUgNQ","content":"AuthLayout_content__3wOCG","title":"AuthLayout_title__2eFw3","title-text":"AuthLayout_title-text__3IwxK"};